import { useEffect, useRef } from "react";
import {
  IG,
  IgIcon,
  SiteFooter,
  SiteNav,
  useSiteStyles,
  WPP,
  WppIcon,
} from "./SiteLayout";

const services = [
  [
    "01",
    "Estratégia Digital",
    "Planejamento estratégico orientado a objetivos de negócio reais.",
  ],
  [
    "02",
    "Pesquisa de Público, Mercado e Concorrentes",
    "Inteligência competitiva para posicionamento diferenciado.",
  ],
  [
    "03",
    "Ghostwriting para Executivos (LinkedIn)",
    "Construção de autoridade pessoal e liderança de pensamento.",
  ],
  [
    "04",
    "Mapeamento da Jornada do Cliente",
    "Entender cada touchpoint para otimizar a experiência de compra.",
  ],
  [
    "05",
    "Web Analytics e Dashboards",
    "Visibilidade total sobre o desempenho digital em tempo real.",
  ],
  [
    "06",
    "Social Media — Gestão e Conteúdo",
    "Instagram, Facebook e LinkedIn com estratégia e consistência.",
  ],
  [
    "07",
    "Produção de Vídeos",
    "Conteúdo audiovisual que conecta, engaja e converte.",
  ],
  [
    "08",
    "Gestão de Tráfego Pago (Ads)",
    "Meta Ads, Google Ads e LinkedIn Ads com foco em ROI.",
  ],
  [
    "09",
    "CRO — Otimização de Conversão",
    "Transformar visitantes em clientes com testes e dados.",
  ],
  [
    "10",
    "SEO — Otimização para Buscadores",
    "Visibilidade orgânica duradoura no Google e Bing.",
  ],
  [
    "11",
    "Inbound Marketing e Materiais Ricos",
    "Ebooks, whitepapers e fluxos que educam e convertem.",
  ],
  [
    "12",
    "E-mail Marketing",
    "Automações e campanhas que nutrem e retêm clientes.",
  ],
  [
    "13",
    "WhatsApp Marketing",
    "Comunicação direta no canal mais usado do Brasil.",
  ],
  [
    "14",
    "Marketing de Influência",
    "Parcerias estratégicas com criadores de conteúdo alinhados à marca.",
  ],
  [
    "15",
    "Marketing de Indicação (Referral)",
    "Programas que transformam clientes em promotores ativos.",
  ],
  [
    "16",
    "Sales Enablement",
    "Materiais que capacitam o time comercial a vender mais.",
  ],
  [
    "17",
    "Branding e Rebranding",
    "Identidade visual e posicionamento de marca com propósito.",
  ],
  [
    "18",
    "Employer Branding",
    "Construção da marca empregadora para atrair e reter talentos.",
  ],
];

const cards = [
  {
    icon: "🎯",
    title: "Estratégia",
    desc: "Diagnóstico real do seu mercado antes de qualquer ação.",
  },
  {
    icon: "📊",
    title: "Dados",
    desc: "Decisões baseadas em analytics, não em achismos.",
  },
  {
    icon: "🚀",
    title: "Crescimento",
    desc: "Performance e conteúdo trabalhando juntos.",
  },
  {
    icon: "✦",
    title: "Resultado",
    desc: "Métricas que importam para o seu negócio.",
  },
];

export default function SolutionFactory() {
  useSiteStyles();

  const revealRefs = useRef([]);

  useEffect(() => {
    // Scroll reveal
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e, i) => {
          if (e.isIntersecting) {
            setTimeout(() => e.target.classList.add("visible"), i * 80);
            observer.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1 },
    );

    revealRefs.current.forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const r = (el) => {
    if (el && !revealRefs.current.includes(el)) revealRefs.current.push(el);
  };

  return (
    <div style={{ background: "#050505", minHeight: "100vh" }}>
      {/* NAV */}
      <SiteNav onHome />

      {/* HERO */}
      <section className="sf-hero">
        <div className="sf-hero-glow" />
        <div className="sf-hero-tag">Agência de Marketing Digital</div>
        <div className="sf-hero-diamond">
          <img src="/icon800.png" alt="Solfac" width={110} height={110} />
        </div>
        <h1>
          RESULTADOS
          <br />
          <span className="grad">que importam</span>
        </h1>
        <p className="sf-hero-sub">
          Estratégia, conteúdo e performance para empresas que querem crescer de
          verdade no digital. Sem fórmulas genéricas.
        </p>
        <div className="sf-hero-actions">
          <a
            href={WPP}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
          >
            <WppIcon size={18} /> Falar no WhatsApp
          </a>
          <a href="#servicos" className="btn-secondary">
            Ver serviços
          </a>
        </div>
        <div className="sf-scroll-indicator">
          <div className="sf-scroll-line" />
        </div>
      </section>

      {/* STATS */}
      <div className="sf-stats">
        {[
          ["100%", "Foco em resultado"],
          ["360°", "Visão estratégica do negócio"],
          ["+19", "Serviços especializados"],
        ].map(([n, l], i) => (
          <div key={i} className="sf-stat" ref={r}>
            <div className="sf-stat-num">{n}</div>
            <div className="sf-stat-label">{l}</div>
          </div>
        ))}
      </div>

      {/* SOBRE */}
      <section id="sobre">
        <div className="sf-section-inner">
          <div className="sf-about-grid">
            <div className="sf-about-text" ref={r}>
              <div className="sf-section-tag">Sobre nós</div>
              <h2 className="sf-section-title">
                SOMOS UMA <span>FÁBRICA</span> DE SOLUÇÕES
              </h2>
              <p>
                A Solution Factory é uma agência de marketing digital{" "}
                <strong>orientada por dados e movida por estratégia</strong>.
                Trabalhamos com empresas que estão prontas para crescer e
                precisam de um parceiro que entenda o negócio de ponta a ponta.
              </p>
              <p>
                Combinamos inteligência de mercado, criatividade e tecnologia
                para criar experiências digitais que{" "}
                <strong>geram resultado mensurável</strong> — mais leads, mais
                conversões, mais autoridade.
              </p>
              <div style={{ marginTop: 36 }}>
                <a
                  href={WPP}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary"
                >
                  Iniciar conversa
                </a>
              </div>
            </div>

            {/* ── CARDS CORRIGIDOS ── */}
            <div className="sf-about-cards" ref={r}>
              {cards.map((c, i) => (
                <div key={i} className="sf-about-card">
                  <div className="sf-about-card-icon">{c.icon}</div>
                  <h4>{c.title}</h4>
                  <p>{c.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* SERVIÇOS */}
      <section id="servicos" className="sf-services">
        <div className="sf-section-inner">
          <div className="sf-services-header">
            <div>
              <div className="sf-section-tag">O que fazemos</div>
              <h2 className="sf-section-title" ref={r}>
                NOSSOS
                <br />
                <span>SERVIÇOS</span>
              </h2>
            </div>
            <p className="sf-services-intro" ref={r}>
              Soluções completas para todas as etapas da presença digital da sua
              empresa — da estratégia à execução.
            </p>
          </div>
          <div className="sf-services-grid" ref={r}>
            {services.map(([num, name, desc]) => (
              <div key={num} className="sf-service-card">
                <div className="sf-service-num">{num}</div>
                <div className="sf-service-name">{name}</div>
                <div className="sf-service-desc">{desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PROCESSO */}
      <section id="processo">
        <div className="sf-section-inner">
          <div className="sf-section-tag" ref={r}>
            Como trabalhamos
          </div>
          <h2 className="sf-section-title" ref={r}>
            NOSSO
            <br />
            <span>PROCESSO</span>
          </h2>
          <div className="sf-process-steps">
            {[
              [
                "01",
                "Diagnóstico",
                "Imersão no negócio, análise de mercado, público e concorrentes para entender onde você está.",
              ],
              [
                "02",
                "Estratégia",
                "Plano de ação personalizado com canais, formatos e KPIs definidos para o seu objetivo.",
              ],
              [
                "03",
                "Execução",
                "Produção e ativação de todas as frentes com agilidade, qualidade e consistência.",
              ],
              [
                "04",
                "Otimização",
                "Análise contínua dos dados para ajustar, escalar e maximizar resultados.",
              ],
            ].map(([n, t, d]) => (
              <div key={n} className="sf-process-step" ref={r}>
                <div className="sf-step-num">{n}</div>
                <div className="sf-step-title">{t}</div>
                <div className="sf-step-desc">{d}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section id="contato" className="sf-cta">
        <div className="sf-cta-inner">
          <div ref={r}>
            <div className="sf-section-tag yellow">Vamos conversar</div>
            <h2 className="sf-section-title">
              PRONTO PARA
              <br />
              <span>CRESCER?</span>
            </h2>
            <p
              style={{
                fontSize: 16,
                fontWeight: 300,
                color: "rgba(255,255,255,.6)",
                maxWidth: 480,
                lineHeight: 1.7,
                marginTop: 12,
              }}
            >
              Entre em contato e descubra como a Solution Factory pode
              transformar a presença digital da sua empresa em resultados reais.
            </p>
          </div>
          <div className="sf-cta-actions" ref={r}>
            <a
              href={WPP}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-wpp-big"
            >
              <WppIcon size={22} /> Falar no WhatsApp
            </a>
            <a
              href={IG}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-ig-big"
            >
              <IgIcon size={22} /> Ver no Instagram
            </a>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <SiteFooter />
    </div>
  );
}
